export default __webpack_public_path__ + "564e86a6592d5a73f4e3323e15a3c74e.png";